import { cx } from './utils';

const PILL_BASE = [
    'inline-flex items-center gap-2 rounded-full border-2 shadow-sm px-4 py-2',
    'bg-white text-sm font-medium text-gray-700 transition-colors duration-200',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400'
].join(' ');

export interface DataTableFilterPillState {
    active?: boolean;
    disabled?: boolean;
    className?: string;
}

// The filter pill's chrome, shared so toolbar buttons placed beside the filters can't drift from them.
export function dataTableFilterPillClasses({
    active = false,
    disabled = false,
    className
}: DataTableFilterPillState = {}): string {
    return cx(
        PILL_BASE,
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50',
        active ? 'border-gray-700' : 'border-gray-300',
        className
    );
}
